const greetings = ['Hi', 'Hey', 'Hello', 'Greetings'];

const superstarNotAvailableBuyoutData = [{
        'subject': 'Not signing',
        'content': 'I\'m sorry but I\'m not open to signing with you. Instead, I\'ll be going to the Indies ' +
            'or maybe even to a new company.'
    },
    {
        'subject': 'Not available',
        'content': 'After the buyout, I\'m not looking to sign with anyone. It\'s time for a break.'
    },
    {
        'subject': 'Thanks but no',
        'content': 'I promised myself I would not jump ship and I\'m not going to do it even after the buyout.'
    }
];

const superstarJoinedInBuyoutTexts = [
    {
        'subject': 'Excited',
        'content': 'I\'m excited to be a part of this company and I can\'t wait to get started.'
    },
    {
        'subject': 'Let\'s start',
        'content': 'Thanks for signing me onto the Main Roster. I\'m ready to start.'
    },
    {
        'subject': 'Much better',
        'content': 'This company already seems so much better. I think I\'ll be a more useful fit here.'
    }
];

const superstarJoinedRamblings = [
    {
        'subject': 'Excited',
        'content': 'I\'m excited to be here and I can\'t wait to get started.'
    },
    {
        'subject': 'Let\'s go',
        'content': 'I\'m here and I\'m ready to start wrestling.'
    },
    {
        'subject': 'Can\'t wait',
        'content': 'This is already so much better than where I was before. I can\'t wait to see what you have ' +
                   'planned for me.'
    },
    {
        'subject': 'Thanks',
        'content': 'It\'s good to be here. Thanks for giving me a chance.'
    },
    {
        'subject': 'Hello',
        'content': 'I\'m glad you signed me. Looking forward to what you have planned for me.'
    },
    {
        'subject': 'Good deal',
        'content': 'That was a good deal you offered me. Hopefully my future here is even better.'
    },
    {
        'subject': 'Fresh start',
        'content': 'I needed a fresh start. Thanks for signing me.'
    },
    {
        'subject': 'Ready',
        'content': 'I\'m ready to start and give you my best.'
    },
];

const superstarLeftRamblings = [
    {
        'subject': 'You\'ll beg me!',
        'content': 'I\'m going to do big things on the Indies. In a few months, you\'re going to beg me to come back, ' +
                   'but I won\'t!'
    },
    {
        'subject': 'Scared',
        'content': 'I\'ll be honest: I\'m scared of being out on my own, but I\'m going to make the best of it.'
    },
    {
        'subject': 'Goodbye',
        'content': 'I\'m glad I could leave right now. Who knows, I might end up coming back. But for now, I need ' +
                   'to be somewhere else.'
    },
    {
        'subject': 'You suck',
        'content': 'You just didn\'t listen to me. You didn\'t care that I was unhappy. Well good riddance. I\'m ' +
                   'sure I can find much better bookers than you.'
    },
    {
        'subject': 'Goodbye',
        'content': 'You know, I\'m really glad I left. Now I can work where I want and be happy with my ' +
                   'wrestling.'
    },
    {
        'subject': 'Big mistake',
        'content': 'You made a big mistake. I\'m going to make you regret booking me so badly.'
    },
    {
        'subject': 'Bad treatment',
        'content': 'There are a lot of places that will treat me a lot better than you did. I\'m glad I left ' +
                   'because I deserve better.'
    }
];

const superstarRamblings = [
    {
        'subject': 'Weird dream',
        'content': `Have you ever dreamed of Martians? Last night I had a pretty weird dream about them. They were ` +
            `all green and they looked so scared, like they were being abused. I tried to help them but they just ` +
            `ran away. I wonder if it all meant anything.`
    },
    {
        'subject': 'Hey',
        'content': `I just wanted to ask: have you ever been in love? I think I might be. I know I shouldn't do anything ` +
            `about it. It would mess up the locker room.`
    },
    {
        'subject': 'Wrestling',
        'content': `This wrestling thing is pretty cool huh? Sometimes I can't believe I do this for a living. ` +
            `Just had a moment where it suddenly hit me how awesome the stories and the business are. Thought I'd share ` +
            `it with you, cause you must love it too.`
    },
    {
        'subject': 'Hi',
        'content': `Just wanted to say hi and tell you that I'm super into my journey of wrestling. I've worked so hard ` +
            `to get here, and I'm ready to go even further.`
    },
    {
        'subject': 'Booker',
        'content': `You ever thought about stepping into the ring? If you do, you better not make it a match with me!`
    },
    {
        'subject': 'Bad day',
        'content': `You ever get low for no reason? Things just get really hard and you don't feel like getting up. ` +
            `Don't worry, I'll be there at the show. Wrestling takes me out of the bad place.`
    },
    {
        'subject': 'Gene editing',
        'content': `You hear about this new gene editing thing? They take genes and insert them into your DNA using a ` +
            `virus. Soon they'll be able to cure diseases. But they could do anything, like making super humans. Maybe they ` +
            `could even clone people! It's terrifying to think about. I don't want to live in a world like that.`
    },
    {
        'subject': 'Trash',
        'content': `There's so much trash in the locker room! I keep telling people to pick it up but I can't always ` +
            `be there. You gotta enforce this stuff. And while you're at it, tell 'em to stop using so much plastic!`
    }
]

const staffRamblings = [
    {
        'subject': 'Wrestling game',
        'content': `Last week, superstars were backstage playing some wrestling game. It looked really fun, and ` +
            `everyone had a great time, but they were all wishing for a game where they could be the manager, so they could play you!`
    },
    {
        'subject': 'Locker room',
        'content': `I was passing by the locker room and saw some of the superstars sitting quietly and eating ` +
            `together. It brought out such a homely feel and I just wanted to share that with you.`
    },
    {
        'subject': 'Stories',
        'content': `Being around the superstars and in the locker room, I've seen a lot of things. I feel like ` +
            `I should write a book about it, but people wouldn't believe the stories!`
    }
]

const mysteriousAdvisorRamblings = [
    {
        'subject': 'Artifacts',
        'content': `Do you ever wonder where these Artifacts came from? Maybe they were built by some ancient ` +
            `civilization and lost to time? Or maybe a sorcerer ensouled the stones with some some powerful magic?`
    },
    {
        'subject': 'Gods',
        'content': `Do you believe in the wrestling gods? I think they put the Artifacts down here on earth, and give ` +
            `them to us when we do things that make them happy.`
    }
]

const ownerRamblings = [
    {
        'subject': 'Hey',
        'content': `Hey pal, you up? Sorry to message you at 4 in the morning. Couldn't sleep.`
    },
    {
        'subject': 'Gym Session',
        'content': `That gym session with the talent was a big mistake. My back hurts so much I can't even bend down at the toilet.`
    },
    {
        'subject': 'Come on!',
        'content': `We gotta work hard to put on a great event for the fans. We gotta show them we can deliver! Let's work on an amazing show.`
    }
]

export {superstarNotAvailableBuyoutData, superstarLeftRamblings, staffRamblings, superstarRamblings, ownerRamblings,
    mysteriousAdvisorRamblings, superstarJoinedRamblings, superstarJoinedInBuyoutTexts, greetings}